import React from "react";
import { Button, Table } from "rsuite";

const { Cell } = Table;

const ActionCell = ({ ...props }) => {
  return (
    <Cell {...props} style={{ padding: "6px" }}>
      <Button
        appearance='link'
        onClick={() => {
          props.onClick(props.rowData.id);
          if (props.rowData.status !== "EDIT") {
          }
        }}
      >
        {props.rowData.status === "EDIT" ? "Speichern" : "Bearbeiten"}
      </Button>
      <Button
        appearance='link'
        onClick={() => {
          props.onDelete(props.rowData.id);
        }}
      >
        Löschen
      </Button>
      {props.onDownload && (
        <Button
          appearance='link'
          onClick={() => {
            props.onDownload(props.rowData.id);
          }}
        >
          PDF erstellen
        </Button>
      )}
    </Cell>
  );
};

export default ActionCell;
